export default "__VITE_ASSET__DfxwYO4___"